"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var gfc;
(function (gfc) {
    gfc[gfc["isGfc"] = 0] = "isGfc";
    gfc[gfc["notGfc"] = 1] = "notGfc";
})(gfc = exports.gfc || (exports.gfc = {}));
var InputShapes;
(function (InputShapes) {
    InputShapes["investmentSmartShield"] = "investmentSmartShield";
    InputShapes["investmentEquivalent"] = "investmentEquivalent";
    InputShapes["investmentBenchmark"] = "investmentBenchmark";
    InputShapes["plain"] = "";
})(InputShapes = exports.InputShapes || (exports.InputShapes = {}));
var Portfolios;
(function (Portfolios) {
    Portfolios["balanced"] = "BALANCED";
    Portfolios["moderate"] = "MODERATE";
    Portfolios["growth"] = "GROWTH";
    Portfolios["highgrowth"] = "HIGHGROWTH";
})(Portfolios = exports.Portfolios || (exports.Portfolios = {}));
var PortfolioContext;
(function (PortfolioContext) {
    PortfolioContext["SS"] = "ss";
    PortfolioContext["Equiv"] = "equiv";
    PortfolioContext["Chosen"] = "chosen";
    PortfolioContext["Undef"] = "undef";
})(PortfolioContext = exports.PortfolioContext || (exports.PortfolioContext = {}));
var RangeTypes;
(function (RangeTypes) {
    RangeTypes["monthly"] = "monthly";
    RangeTypes["daily"] = "daily";
})(RangeTypes = exports.RangeTypes || (exports.RangeTypes = {}));
//# sourceMappingURL=DataInterfaces.js.map